import { useMemo, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

import useTranslations from "@/shared/lang/useTranslations";

type CardsHeaderProps = {
  activeTabId?: string;
  subtitle?: string;
  actions?: ReactNode;
};

export const CardsHeader = ({ activeTabId, subtitle, actions }: CardsHeaderProps) => {
  const { t } = useTranslations("cards");
  const location = useLocation();

  const currentTabId = useMemo(
    () => activeTabId || location.pathname.split("/").pop() || "cards",
    [activeTabId, location.pathname],
  );

  const pageTitle = useMemo(() => {
    if (currentTabId === "identities") return t("cards_header_title_identities");
    if (currentTabId === "organizations") return t("cards_header_title_organizations");
    if (currentTabId === "cards") return t("cards_header_title_cards");
    if (currentTabId === "pockets") return t("cards_header_title_pockets");
    if (currentTabId === "movements") return t("cards_header_title_movements");
    return t("cards_header_title_cards");
  }, [currentTabId, t]);

  return (
    <header className="flex flex-wrap items-center justify-between gap-4">
      <div className="min-w-0">
        <h1 className="truncate text-2xl font-semibold leading-tight tracking-tight text-foreground">
          {pageTitle}
        </h1>
        {subtitle && <p className="mt-1 truncate text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
};
